/**
 * Read a CRA env var; fail fast if unset or blank.
 * @param {string} name - process.env key, e.g. REACT_APP_BACKEND_URL
 * @returns {string}
 */
export function requiredEnv(name) {
  const value = process.env[name];
  if (value == null || String(value).trim() === '') {
    throw new Error(
      `Missing required environment variable: ${name}. Add it to .env or .env.production.`
    );
  }
  return String(value).trim();
}
